<script lang="ts">
    import CTA from "./CTA.svelte";
    import Image from "./Image.svelte";
    import type { CTA as CTA_TYPE} from "../../types";
    import type { ImageType } from "../../types";
    import { PortableText } from "@portabletext/svelte";
    import type { InputValue } from "@portabletext/svelte/ptTypes";
    import { assets as assetPath } from "$app/paths";
    import InfoPill from "./InfoPill.svelte";

    export let heading : string = ''
    export let content : string | InputValue
    export let cta : CTA_TYPE = {text: ''}
    export let image : ImageType
    export let theme : 'dark' | 'light' = 'dark'
    export let fullWidth : boolean = false
    export let betaFeatures : boolean = false

    //TODO remove when text content is no longer support
    export let portabletext : boolean = false

</script>

<div class="info-banner" class:light={theme === 'light'} class:fullwidth={fullWidth}>
    <Image pngUrl={image.pngUrl} alt={image?.alt} webpUrl={image?.webpUrl} className="info-banner__image"/>
    <div class="info-banner__content">
        {#if heading}<h3 class="info-banner__content__heading">{heading} { #if betaFeatures }<img src="{assetPath}/assets/sparkle.png" alt="blue sparkel image"/><InfoPill text="Beta"/>{/if}</h3>{/if}
        {#if portabletext}<p>{content}</p>{:else}<PortableText value={content} />{/if}
    </div>
    {#if cta.text}<CTA text={cta.text} className="info-banner__cta" url={cta.url} theme={cta.theme ? cta.theme : 'filled'} on:click/>{/if}
</div>

<style lang="postcss">
    @import '../../styles/_mixins.css';

    .info-banner {
        width: 1200px;
        margin:0;
        background-color: var(--color_offerzen_navy);
        height:130px;
        display: flex;
        align-items: center;
        gap:40px;
        border-radius:10px;
        padding: 24px;

        @mixin screen-lg {
            max-width:800px;
        }

        @mixin screen-md {
            gap:40px;
            width:100%;
            height:100%;
        }

        @mixin screen-sm {
            width:100%;
            flex-direction:column;
            align-items:flex-start;
            gap:0;
            padding:32px;
        }

        & :global(.info-banner__image) {

            height:100px;
            @mixin screen-md {
                display:none;
            }
        }

        & :global(.info-banner__cta) {
            padding:20px;
            margin:0 0 0 auto;
        }

        & .info-banner__content {

            & .info-banner__content__heading {
                font-size:22px;
                margin:0 0 3px;
                color:var(--color_white);
                font-weight:600;
                display: inline-block;

                & img {
                    height:20px;
                    margin:-5px 8px;
                }

                @mixin screen-sm {
                    margin:0 0 8px;
                }
            }

            & :global(p), & p {
                margin:0;
                font-size:18px;
                color:var(--color_offerzen_lightblue_secondary);
                line-height:150%;

                @mixin screen-md {
                    font-size:16px;
                }

                @mixin screen-sm {
                    margin:0 0 16px;
                }
            }
        }
    }

    .light {
        background-color: var(--color_offerzen_lightblue_secondary) !important;

        & .info-banner__content {

            & .info-banner__content__heading {
                color: var(--color_offerzen_navy);
            }
            & p {
                color: var(--color_offerzen_navy);
            }
        }
    }

    .fullwidth {
        width:100%;
        border-radius: 0px;
        max-width:100%;

        @mixin screen-xxl {
            padding:0 230px;
        }

        @mixin screen-md {
            padding:32px 80px;
        }

        @mixin screen-sm {
            padding:32px;
        }

        & :global(.info-banner__image) {
            margin-left:auto;

            @mixin screen-md {
                margin:inherit;
            }
        }

        & :global(.info-banner__cta) {
            margin-right:auto;
        }
    }

</style>